import { Factory } from './Factory'
import { ColumnFactory} from './ColumnFactory'
import Menu from '../EditorElements/RowModule/Menu'

export class RowFactory extends Factory {
  constructor(qty = 1) {
    super()
    this.qty = qty
  }

  create(data) {
    this.rows = this.mapRows(data)
    let rows = this.rows.map(row => {
      let id = this.id('row')
      return {...row, id}
    })
    return rows
  }

  mapRows(data) {
    if (data) {
      return data
    }

    let rows = []
    for (let x = 1; x <= this.qty; x++) {
      rows.push(this.markup(x))
    }
    return rows
  }

  markup() {
    return {
      name: 'row',
      properties: {
        styles: [
          {key: 'columns-gap', component:'ColumnsGapProperty'},
          {key: 'container', component:'ContainerProperty', class:'containerClasses'},
          {key: 'background-color', component:'BackgroundProperty'},
          {key: 'border', component:'BorderProperty'},
          {key: 'margin', component:'MarginProperty'},
          {key: 'padding', component:'PaddingProperty'},
          {key: 'display', component: 'DisplayInDeviceProperty'},
        ],
        advanced: [
          {key: 'element-id', component: 'ElementId'},
          {key: 'custom-classes', component: 'CustomClasses'},
          {key: 'custom-styles', component: 'CustomStyles'},
        ],
        menu: Menu
      },
      assets: {
        phone: [],
        tablet: [],
        desktop: []
      },
      styles: {
        phone: [],
        tablet: [],
        desktop: []
      },
      containerClasses: {
        phone: [],
        tablet: [],
        desktop: []
      },
      classes: {
        phone: [
          {property: 'PaddingTop', value: 'PADDING_TOP_NONE'},
          {property: 'PaddingLeft', value: 'PADDING_LEFT_NONE'},
          {property: 'PaddingBottom', value: 'PADDING_BOTTOM_NONE'},
          {property: 'PaddingRight', value: 'PADDING_RIGHT_NONE'},
        ],
        tablet: [
          {property: 'PaddingTop', value: 'PADDING_TOP_NONE'},
          {property: 'PaddingLeft', value: 'PADDING_LEFT_NONE'},
          {property: 'PaddingBottom', value: 'PADDING_BOTTOM_NONE'},
          {property: 'PaddingRight', value: 'PADDING_RIGHT_NONE'},
        ],
        desktop: [
          {property: 'PaddingTop', value: 'PADDING_TOP_NONE'},
          {property: 'PaddingLeft', value: 'PADDING_LEFT_NONE'},
          {property: 'PaddingBottom', value: 'PADDING_BOTTOM_NONE'},
          {property: 'PaddingRight', value: 'PADDING_RIGHT_NONE'},
        ]
      },
      columns: (new ColumnFactory).create(),
      background: {
        phone: 'color',
        tablet: 'color',
        desktop: 'color'
      },
      customClasses: []
    }
  }
}